import { CUSTOMER_REVIEW_ACTION_ENABLE_PROCESSING, CUSTOMER_REVIEW_APPROVED } from 'constants/index';

/**
 * customer_review_required is set by the API only when the order is made to
 * order AND its seller is configured with madeToOrderReviewRequired. Those
 * orders can only be accepted once the customer approves the product images the
 * seller added in the app, or once the Danube team overrides a rejection with
 * "Enable Order Processing". Every other order runs on the normal flow.
 */
export const isMadeToOrderAcceptBlocked = (order) => {
  if (!order?.customer_review_required) {
    return false;
  }
  const customerReview = order?.customerReview;
  return customerReview?.customerResponse !== CUSTOMER_REVIEW_APPROVED && customerReview?.adminAction !== CUSTOMER_REVIEW_ACTION_ENABLE_PROCESSING;
};

export default isMadeToOrderAcceptBlocked;
